import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { type SupportContext } from "@src/appV2/support/constants";
import { ContactSupportTextButton } from "@src/appV2/support/ContactSupportTextButton";
import { type ReactElement } from "react";

interface Props {
  authMethod: string;
  supportContext: SupportContext;
}

export function TryDifferentAuthMethodSection(props: Props): ReactElement {
  const { authMethod, supportContext } = props;

  return (
    <Stack spacing={4}>
      <Text variant="body1">Try logging in with a different {authMethod}.</Text>
      <Stack spacing={2} sx={{ alignItems: "center" }}>
        <Text variant="body1">If you think this is an error, then please contact our </Text>
        <ContactSupportTextButton supportContext={supportContext} />
      </Stack>
    </Stack>
  );
}
